import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import withStyles from '@material-ui/core/styles/withStyles'

import { createFlyerThumbPath } from 'utils'

const styles = theme => ({
  imageContainer: {
    flex: '1 1 auto',
    position: 'relative',
    background: theme.colors.flyerBackground || theme.colors.darkGrey,
  },
  image: {
    padding: theme.spacing(2),
    display: 'block',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '100%',
  },
})

const ViewerSkeleton = ({
  intl: { locale },
  flyerId,
  classes,
  className,
}) => (
  <div className={`${classes.imageContainer} ${className}`}>
    <img className={classes.image} src={createFlyerThumbPath(locale, flyerId)} alt="" />
  </div>
)

ViewerSkeleton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  flyerId: PropTypes.string.isRequired,
  className: PropTypes.string,
}

ViewerSkeleton.defaultProps = {
  className: null,
}

const WithStylesViewerSkeleton = withStyles(styles)(ViewerSkeleton)

export default injectIntl(WithStylesViewerSkeleton)
